/* Reveal observer */
(function(){
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('on');obs.unobserve(e.target);}
    });
  },{threshold:.08,rootMargin:'0px 0px -32px 0px'});
  document.querySelectorAll('.rv').forEach(function(el){obs.observe(el);});
})();

/* Partner reveal */
function togglePartner(btn) {
  var mores = btn.parentElement.querySelectorAll('.partner-more');
  var isOpen = btn.classList.contains('open');
  mores.forEach(function(el) { el.style.display = isOpen ? 'none' : 'block'; });
  btn.classList.toggle('open', !isOpen);
  btn.innerHTML = isOpen
    ? 'Voir plus <i class="ti ti-chevron-down"></i>'
    : 'Voir moins <i class="ti ti-chevron-up"></i>';
}
